import cn from "classnames";
import React from "react";
import { AlignmentOptions } from "components/pdfViewer/types";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type ButtonBlockType = Omit<FormBlockType, "data"> & {
    data: {
        url: string;
        label: string;
        align: AlignmentOptions
    },
}

export default function ButtonBlock(block: ButtonBlockType) {
    const { align, label, url } = block.data;
    const alignmentCn = cn(
        { "text-left": align == "left" },
        { "text-center": align == "center" },
        { "text-right": align == "right" },
        "py-2"
    );

    return (
        <div className={alignmentCn}>
            <a
                href={url}
                target={"_blank"}
                className={`rounded-md bg-button px-4 py-2 text-btnTextColor transition-all hover:bg-button/80 active:shadow-primary-active`}
            >
                {label}
            </a>
        </div>
    );
}
